import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Tooltip, Checkbox } from 'antd'
import { Icon, Div } from 'konsys-ui'
import {
  InputWithPlaceHolder, SerialActionSelector, HeaderLabel, CellText, DropdownSelector,
} from '../../../components/tire-inventory-components'
import { theme } from '../../../styles/_variables'
import { STATUS, STATUSTEXTSELECTOR } from '../constants'

const { color } = theme

export default {
  columns: [{
    Header: () => <HeaderLabel>เบอร์ยาง</HeaderLabel>,
    accessor: 'serialNumber',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ทะเบียนรถ</HeaderLabel>,
    accessor: 'Tire.TireType.name',
    sortable: false,
    filterable: true,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ประเภทรถ</HeaderLabel>,
    accessor: 'brand',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 100,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ตำแหน่งล้อ</HeaderLabel>,
    accessor: 'inventoryOptions[0].option1.optionName',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 100,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>คลังสินค้า</HeaderLabel>,
    accessor: 'Warehouse.warehouseName',
    sortable: false,
    filterable: false,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 300,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>วันที่รับเข้า</HeaderLabel>,
    accessor: 'createdAt',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{STATUSTEXTSELECTOR(props.value)}</CellText>,
    Filter: ({ onChange }) => <DropdownSelector
    key='filter'
    data={STATUS}
    handleChange={e => onChange(e)}
    filter={true}
    statusAttr='ทั้งหมด'
    />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 100,
    margin: '0 50px',
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <SerialActionSelector props={props} refetch={() => props.tdProps.rest.refetch()} warehousesData={props.tdProps.rest.warehousesData}/>,
    width: 150,
  }],
}
export const columnConfig = ({
  checkAll,
}) => ([{
  Header: () => <HeaderLabel>เบอร์ยาง</HeaderLabel>,
  accessor: 'serialNumber',
  sortable: false,
  filterable: true,
  Cell: props => <CellText>{props.value}</CellText>,
  Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
  filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
  width: 150,
  margin: '0 50px',
}, {
  Header: () => <HeaderLabel>ทะเบียนหัว</HeaderLabel>,
  accessor: 'TruckTires.Truck.plateNumber',
  sortable: false,
  filterable: true,
  Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
  Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
  filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
  width: 150,
  margin: '0 50px',
}, {
//   Header: () => <HeaderLabel>ประเภทหัว</HeaderLabel>,
//   accessor: 'TruckTires.Truck.type.nameTh',
//   sortable: false,
//   filterable: false,
//   Cell: props => <CellText>{props.value}</CellText>,
//   Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
//   filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
//   width: 100,
//   margin: '0 50px',
// }, {
  Header: () => <HeaderLabel>ทะเบียนหาง</HeaderLabel>,
  accessor: 'TrailerTires.Trailer.trailerPlate',
  sortable: false,
  filterable: true,
  Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
  Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
  filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
  width: 150,
  margin: '0 50px',
}, {
//   Header: () => <HeaderLabel>ประเภทหาง</HeaderLabel>,
//   accessor: 'TrailerTires.Trailer.type.nameTh',
//   sortable: false,
//   filterable: false,
//   Cell: props => <CellText>{props.value}</CellText>,
//   Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
//   filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
//   width: 100,
//   margin: '0 50px',
// }, {
  Header: () => <HeaderLabel>ตำแหน่งล้อ</HeaderLabel>,
  accessor: 'TruckTires.wheelNo',
  sortable: false,
  filterable: false,
  Cell: props => <CellText>{props.value}</CellText>,
  Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
  filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
  width: 100,
  margin: '0 50px',
}, {
  Header: () => <HeaderLabel>คลังสินค้า</HeaderLabel>,
  accessor: 'Warehouse.warehouseName',
  sortable: false,
  filterable: false,
  Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
  Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
  filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
  width: 300,
  margin: '0 50px',
}, {
  Header: () => <HeaderLabel>วันที่รับเข้า</HeaderLabel>,
  accessor: 'createdAt',
  sortable: false,
  filterable: false,
  Cell: props => <CellText>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
  Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
  filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
  width: 150,
  margin: '0 50px',
}, {
  Header: () => <HeaderLabel>สถานะ</HeaderLabel>,
  accessor: 'status',
  sortable: false,
  filterable: true,
  Cell: props => <CellText>{STATUSTEXTSELECTOR(props.value)}</CellText>,
  Filter: ({ onChange }) => <DropdownSelector
    key='filter'
    data={STATUS}
    handleChange={e => onChange(e)}
    filter={true}
    statusAttr='ทั้งหมด'
    />,
  filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
  width: 100,
  margin: '0 50px',
}, {
  Header: () => <HeaderLabel>เหตุผลในการนำออก</HeaderLabel>,
  accessor: 'lostReason',
  sortable: false,
  filterable: false,
  Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
  Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
  filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
  width: 150,
  margin: '0 50px',
}, {
  Header: null,
  accessor: 'action',
  sortable: false,
  filterable: false,
  Cell: props => <SerialActionSelector props={props} refetch={() => props.tdProps.rest.refetch()} warehousesData={props.tdProps.rest.warehousesData}/>,
  width: 150,
}])
